@if (loading) {
  <app-loader [isLocal]="true"></app-loader>
}
@if (loadError) {
  <div class="load-error" role="alert">
    <span>{{ data.length ? ('TABLE.refresh_failed' | translate) : ('TABLE.load_failed' | translate) }}</span>
    <button (click)="reloader.next(undefined)" type="button" mat-button color="primary">{{ 'TABLE.retry' | translate }}</button>
  </div>
}
@if (loading && !data.length) {
  <app-not-found [text]="'TABLE.loading' | translate"></app-not-found>
}
@if (!loading && !loadError && !data.length) {
  <app-not-found [text]="noDataText"></app-not-found>
}

@if (!virtualScroll) {
  <ng-container select="app-list-container">
    @for (item of data; track trackByIndex(i, item); let i = $index) {
      <div class="grid">
        <ng-container
          [ngTemplateOutlet]="eagerProvider?.template || paginatedProvider?.template"
          [ngTemplateOutletContext]="{ $implicit: item }">
          <ng-content select="app-list-head"></ng-content>
          <ng-content select="app-list-body"></ng-content>
        </ng-container>
        <ng-content select="app-list-actions"></ng-content>
      </div>
    }
  </ng-container>
} @else {
  <cdk-virtual-scroll-viewport class="virtual-list" [itemSize]="416">
    <div *cdkVirtualFor="let row of virtualRows" class="virtual-row">
      <ng-container select="app-list-container">
        @for (item of row; track trackByIndex(i, item); let i = $index) {
          <div class="grid">
            <ng-container
              [ngTemplateOutlet]="eagerProvider?.template || paginatedProvider?.template"
              [ngTemplateOutletContext]="{ $implicit: item }">
              <ng-content select="app-list-head"></ng-content>
              <ng-content select="app-list-body"></ng-content>
            </ng-container>
            <ng-content select="app-list-actions"></ng-content>
          </div>
        }
      </ng-container>
    </div>
  </cdk-virtual-scroll-viewport>
}

@if (paginatedProvider) {
  <mat-paginator (page)="paginatedProvider.loadPage($event, filter, ordering)"
    [length]="paginatedProvider.total"
    [pageIndex]="paginatedProvider.pageIndex"
    [pageSizeOptions]="paginatedProvider.sizes"
    [pageSize]="paginatedProvider.limit"
    class="paginator">
  </mat-paginator>
}
